"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));

var _Input = _interopRequireDefault(require("@mui/material/Input"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Button = _interopRequireDefault(require("@mui/material/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ClearSharp = _interopRequireDefault(require("@mui/icons-material/ClearSharp"));

var _SearchSharp = _interopRequireDefault(require("@mui/icons-material/SearchSharp"));

var _useBreakpoint = require("./useBreakpoint");

var _enhancers = require("./enhancers");

var _withSearchState = require("./enhancers/withSearchState");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOptionLabel = function getOptionLabel(option) {
  return typeof option === 'string' ? option : option.label;
};

var filterOptions = function filterOptions(options) {
  var counts = {};
  return options.filter(function (option) {
    counts[option.facet] = counts[option.facet] || 0;
    return counts[option.facet]++ < 3;
  });
};

var onOptionChange = function onOptionChange(searchPhrase, handleSearchInputChange) {
  return function (_, value) {
    var phrase = '';

    if (value) {
      if (value.facet) {
        var _classifySearchPhrase = (0, _withSearchState.classifySearchPhrase)(searchPhrase),
            criterions = _classifySearchPhrase.criterions;

        phrase = (0, _withSearchState.constructSearchPhrase)({
          keywords: [],
          criterions: _objectSpread(_objectSpread({}, Object.keys(criterions).reduce(function (acc, key) {
            return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, criterions[key].map(function (v) {
              return {
                key: v
              };
            })));
          }, {})), {}, _defineProperty({}, value.facet, [].concat(_toConsumableArray((criterions[value.facet] || []).map(function (v) {
            return {
              key: v
            };
          })), [value.value])))
        });
      } else {
        phrase = searchPhrase;
      }
    }

    handleSearchInputChange({
      target: {
        value: phrase
      }
    });
  };
};

var onChange = function onChange(intl, setSearchPhraseInternal, setOptions, facetCriteria) {
  return function (event) {
    var phrase = event.target.value || '';
    setSearchPhraseInternal(phrase);
    var criteria = (0, _withSearchState.classifySearchPhrase)(phrase);
    var searchBy = {
      label: intl.formatMessage({
        id: 'searchBox.searchBy'
      }, {
        phrase: criteria.keywords.join(' ')
      }),
      value: criteria.keywords.join(' ')
    };
    setOptions([searchBy]);
    Promise.all(Object.keys(facetCriteria).map(function (key) {
      return facetCriteria[key].suggestions && facetCriteria[key].suggestions(criteria.keywords.join(' ')).then(function (opts) {
        return {
          facet: key,
          options: opts
        };
      });
    }).filter(Boolean)).then(function (suggestions) {
      var opts = suggestions.flatMap(function (_ref) {
        var facet = _ref.facet,
            $options = _ref.options;
        return $options // eslint-disable-next-line max-nested-callbacks
        .filter(function (option) {
          return !!option.label;
        }) // eslint-disable-next-line max-nested-callbacks
        .map(function (option) {
          return {
            label: option.label,
            value: option,
            facet: facet
          };
        });
      });
      setOptions([searchBy].concat(_toConsumableArray(opts)));
    });
  };
};

var SearchInput = function SearchInput(_ref2) {
  var intl = _ref2.intl,
      classes = _ref2.classes,
      facets = _ref2.facets,
      dataQeId = _ref2.dataQeId,
      ariaLabel = _ref2.ariaLabel,
      autoFocus = _ref2.autoFocus,
      searchHintLabel = _ref2.searchHintLabel,
      hideSearch = _ref2.hideSearch,
      searchPhrase = _ref2.searchPhrase,
      setSearchPhraseInternal = _ref2.setSearchPhraseInternal,
      makeHandleSearchInputChange = _ref2.makeHandleSearchInputChange,
      makeHandleClearSearchTerm = _ref2.makeHandleClearSearchTerm,
      handleSearchInputFocus = _ref2.handleSearchInputFocus,
      makeHandleSearchInputSearch = _ref2.makeHandleSearchInputSearch;
  var facetCriteria = (0, _enhancers.useContextualFacets)(facets).reduce(function (acc, _ref3) {
    var tag = _ref3.tag,
        options = _ref3.options,
        matchOption = _ref3.matchOption,
        selected = _ref3.selected,
        setSelected = _ref3.setSelected,
        suggestions = _ref3.suggestions;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, tag, {
      options: options,
      matchOption: matchOption,
      selected: selected,
      setSelected: setSelected,
      suggestions: suggestions
    }));
  }, {});
  var isMobile = (0, _useBreakpoint.useIsBreakpointDown)('xs');

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      changed = _useState2[0],
      setChanged = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      options = _useState6[0],
      setOptions = _useState6[1];

  var show = (0, _react.useCallback)(function () {
    return setOpen(true);
  }, [setOpen]);
  var hide = (0, _react.useCallback)(function () {
    return setOpen(false);
  }, [setOpen]);
  var handleSearchInputChange = (0, _react.useMemo)(function () {
    return makeHandleSearchInputChange(facetCriteria);
  }, [facetCriteria, makeHandleSearchInputChange]);
  var handleClearSearchTerm = (0, _react.useCallback)(function () {
    setChanged(false);
    makeHandleClearSearchTerm(facetCriteria)();
  }, [facetCriteria, makeHandleClearSearchTerm]);
  var handleSearchInputSearch = (0, _react.useMemo)(function () {
    return makeHandleSearchInputSearch(facetCriteria);
  }, [facetCriteria, makeHandleSearchInputSearch]);
  var onSearchInputKeyPress = (0, _react.useCallback)(function (event) {
    if (event.key && event.key.length > 1 && event.key !== 'Backspace' && event.key !== 'Enter' && event.key !== 'Delete') {
      return;
    }

    if (event.key === 'Enter') {
      setChanged(false);
      handleSearchInputSearch();
      hide();
    } else {
      setChanged(true);
    }
  }, [setChanged, handleSearchInputSearch, hide]);
  var onSearchInputSearch = (0, _react.useCallback)(function () {
    setChanged(false);
    handleSearchInputSearch();
  }, [setChanged, handleSearchInputSearch]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    classes: {
      root: classes.inputRoot
    },
    disableClearable: true,
    getOptionLabel: getOptionLabel,
    filterOptions: filterOptions,
    options: options,
    freeSolo: true,
    open: searchPhrase !== '' && open,
    onOpen: show,
    onClose: hide,
    value: {
      label: searchPhrase,
      value: searchPhrase
    },
    onChange: onOptionChange(searchPhrase, handleSearchInputChange),
    renderInput: function renderInput(_ref4) {
      var ref = _ref4.ref,
          InputProps = _ref4.InputProps,
          inputProps = _ref4.inputProps;

      var props = _objectSpread(_objectSpread({
        autoComplete: 'off'
      }, ariaLabel ? {
        'aria-label': ariaLabel
      } : {}), inputProps);

      delete props.className;
      delete props.value;
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
        ref: ref,
        inputProps: props,
        "data-qe-id": dataQeId,
        autoFocus: autoFocus,
        placeholder: searchHintLabel,
        autoComplete: "off",
        "aria-describedby": "search-filters",
        spellCheck: "off",
        disableUnderline: true,
        type: "text",
        disabled: hideSearch,
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput
        },
        value: searchPhrase,
        onChange: onChange(intl, setSearchPhraseInternal, setOptions, facetCriteria),
        onFocus: function onFocus() {
          show();
          handleSearchInputFocus();
        },
        onBlur: hide,
        onKeyDown: onSearchInputKeyPress
      }, InputProps));
    },
    renderOption: function renderOption(props, option) {
      if (option.facet) {
        var facet = facets.find(function (f) {
          return f.tag === option.facet;
        });

        if (facet && facet.SuggestionItem) {
          var SuggestionItem = facet.SuggestionItem;
          return /*#__PURE__*/_react["default"].createElement("li", props, /*#__PURE__*/_react["default"].createElement(SuggestionItem, {
            option: option.value
          }));
        }
      }

      return /*#__PURE__*/_react["default"].createElement("li", props, getOptionLabel(option));
    }
  }), searchPhrase.length > 0 && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": intl.formatMessage({
      id: 'searchBox.clear'
    }),
    "data-qe-id": "".concat(dataQeId, "_Clear"),
    className: (0, _classnames["default"])(classes.iconButton, classes.clearButton),
    onClick: handleClearSearchTerm,
    size: "large"
  }, /*#__PURE__*/_react["default"].createElement(_ClearSharp["default"], null)), changed && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    variant: "contained",
    "aria-label": intl.formatMessage({
      id: 'searchBox.applySearch'
    }),
    classes: {
      root: (0, _classnames["default"])(classes.searchButton, changed && classes.searchButtonUnappliedChanges),
      label: classes.searchButtonLabel
    },
    onClick: onSearchInputSearch
  }, isMobile ? /*#__PURE__*/_react["default"].createElement(_SearchSharp["default"], {
    className: classes.searchButtonIcon
  }) : intl.formatMessage({
    id: 'search.title'
  })));
};

var _default = (0, _reactIntl.injectIntl)(SearchInput);

exports["default"] = _default;